module.exports = __webpack_public_path__ + "static/media/test.de138206.svg";